import { ratesStructureAdd } from "api/rates";
import { RatesStructureAddBody } from "api/types/rates";
import { notifySimple } from "providers/toast";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setLoading } from "store/appSlice";
import { formatDateToZ } from "util/datelib";
import RateStructureForm, {
  RateStructureFormType,
} from "widgets/forms/rates/ratesStructure";
import GenericDialog from "./generic";

const RateStructureDialog = (props: {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
}) => {
  const { isOpen, onClose, onSuccess } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();

  // Function for linking an user
  const doAddRateStructure = async (formData: RateStructureFormType) => {
    dispatch(setLoading(true));
    const body: RatesStructureAddBody = {
      name: formData.name,
      publicFlag: formData.publicFlag,
      billingDate: formData.billingDate,
      vatInclusive: formData.vatInclusive,
      startDate: formatDateToZ(formData.startDate),
      endDate: formatDateToZ(formData.endDate),
    };

    const { status } = await ratesStructureAdd(body);
    dispatch(setLoading(false));
    if (status === 200) {
      onSuccess();
        notifySimple(t("notification.rate.structure.success"), "success");
      } else {
        notifySimple(t("notification.rate.structure.error"), "error");
      }
    };

    return (
      <GenericDialog
        isOpen={isOpen}
        title={t("dialog.rate.structure.title")}
      onExit={onClose}
    >
      <RateStructureForm
        submit={(data) => {
          doAddRateStructure(data);
        }}
        onClose={onClose}
      />
    </GenericDialog>
  );
};

export default RateStructureDialog;
